/**
 * @generated SignedSource<<f3f2a65ec7cc34a36964d7caee28fc8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TemplateAuthor_Author$data = {
  readonly __typename: "Account";
  readonly logo: string;
  readonly name: string;
  readonly " $fragmentType": "TemplateAuthor_Author";
} | {
  readonly __typename: "ExternalAccount";
  readonly logo: string;
  readonly name: string;
  readonly " $fragmentType": "TemplateAuthor_Author";
} | {
  readonly __typename: "TemplateCompanyAuthor";
  readonly darkModeLogo: string | null;
  readonly logo: string;
  readonly name: string;
  readonly " $fragmentType": "TemplateAuthor_Author";
} | {
  readonly __typename: "TemplateIconAuthor";
  readonly color: string | null;
  readonly icon: string | null;
  readonly nameThatIsOptional: string | null;
  readonly " $fragmentType": "TemplateAuthor_Author";
} | {
  readonly __typename: "TemplateUserAuthor";
  readonly fullName: string;
  readonly image: string;
  readonly " $fragmentType": "TemplateAuthor_Author";
} | {
  readonly __typename: "User";
  readonly fullName: string;
  readonly id: string;
  readonly image: string;
  readonly " $fragmentType": "TemplateAuthor_Author";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "TemplateAuthor_Author";
};
export type TemplateAuthor_Author$key = {
  readonly " $data"?: TemplateAuthor_Author$data;
  readonly " $fragmentSpreads": FragmentRefs<"TemplateAuthor_Author">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TemplateAuthor_Author",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v3/*: any*/),
      "type": "Account",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v3/*: any*/),
      "type": "ExternalAccount",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": "fullName",
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "type": "TemplateUserAuthor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "darkModeLogo",
          "storageKey": null
        }
      ],
      "type": "TemplateCompanyAuthor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "icon",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        {
          "alias": "nameThatIsOptional",
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "type": "TemplateIconAuthor",
      "abstractKey": null
    }
  ],
  "type": "NoteTemplateAuthor",
  "abstractKey": "__isNoteTemplateAuthor"
};
})();

(node as any).hash = "8be5761fc858c55ab1088ae70c71fa66";

export default node;
